import styled from "styled-components";

export const TextQuestion = styled.h1`
	font-size: 20px;
	color: #000;
	text-align: center;
	font-style: normal;
	font-weight: 600;
	line-height: 24px; /* 120% */
	letter-spacing: 1.2px;
	div {
		display: inline !important;
	}
`;

export const AnswerDiv = styled.div`
	border-radius: 4px;
	border-width: 1px;
	border-style: solid;
	display: flex;
	padding: 14px 24px;
	align-items: center;
	gap: 48px;
	align-self: stretch;
`;
export const PageTitle = styled.span`
	color: #000;
	text-align: center;
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
	line-height: 24px; /* 120% */
	letter-spacing: 1.2px;
	display: flex;
	justify-content: center;
`;

export const ImageStyle = styled.img`
	max-width: 50%;
`;
export const AnswersWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;
export const AnswerContainer = styled.div`
	width: 100%;
`;

export const AnswerText = styled.div`
	word-break: break-word !important;
	hyphens:auto !important;
	`
